import { render, staticRenderFns } from "./MatchPairs.vue?vue&type=template&id=38871e31&scoped=true"
import script from "./MatchPairs.vue?vue&type=script&lang=ts"
export * from "./MatchPairs.vue?vue&type=script&lang=ts"
import style0 from "./MatchPairs.vue?vue&type=style&index=0&id=38871e31&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38871e31",
  null
  
)

export default component.exports